import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Overlay} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Overlay';
import {Page} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {PageOverlayTabsContextMenu} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/area/contextMenu/pageOverlaysTabs/PageOverlayTabsContextMenu';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./PageOverlaysTabs.less');
const cx = classnames.bind(styles);

export interface BoxTitleProps
{
    page:Page;
    className?:string;
}

@observer
export class PageOverlaysTabs extends React.Component<BoxTitleProps, any>
{
    private _handleTabMouseDown = (event:React.MouseEvent<HTMLElement>):void =>
    {
        const {page} = this.props;
        const overlayId:string = (event.target as any).dataset.overlayId;

        const overlay:Overlay = page.overlays.find((target:Overlay) => target.page.id === overlayId);

        if( event.button !== 2 )
            controllers.ui.surfaceArea.setActiveOverlay(overlay, page.id);

        if( overlay )
            controllers.ui.surfaceSelection.setSingleBoxSelection(overlay.page.artboard.viewport);
    };

    render()
    {
        const {className, page} = this.props;
        const {activeOverlay} = page;

        return (
            <div
                data-box-title="true"
                className={cx('pageOverlaysTabs', {[className]: !!className})}
            >
                <div
                    className={cx('tab', 'first', {active: activeOverlay === null})}
                    onMouseDown={this._handleTabMouseDown}
                >
                    {page.name}
                </div>

                {page.overlays.map((overlay:Overlay) =>
                {
                    return (
                        <PageOverlayTabsContextMenu overlay={overlay} key={overlay.page.id}>
                            <div
                                className={cx('tab', {
                                    active: activeOverlay === overlay,
                                    hidden: overlay.isHidden,
                                    pinned: overlay.isPinned
                                })}
                                onMouseDown={this._handleTabMouseDown}
                                // it uses in this._handleMouseDown and also in handleMouseDownCapture in SurfaceAreaContextMenu
                                data-overlay-id={overlay.page.id}
                            >
                                {overlay.isPinned && <MDIcon
                                    className={cx('pinIcon')}
                                    name={MDIcons.common.Pin}
                                    size={MDIconSize.medium16}
                                />}
                                <span className={cx('title')}>{overlay.page.name}</span>
                            </div>
                        </PageOverlayTabsContextMenu>
                    );
                })}
            </div>
        );
    }
}
